import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import "./PaymentSuccessScreen.css";

const PaymentSuccessScreen = ({ customMessage }) => {
  const [countdown, setCountdown] = useState(15);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    console.log("Payment success screen opened");

    // Allow success redirect without browser leave warning
    window.__ALLOW_PAYMENT_SUCCESS_REDIRECT = true;

    window.scrollTo({ top: 0, behavior: "smooth" });

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) return 0;
        return prev - 1;
      });
    }, 1000);

    const redirectTimer = setTimeout(() => {
      setIsVisible(false);
      window.__ALLOW_PAYMENT_SUCCESS_REDIRECT = true;
      window.location.replace("/");
    }, 15000);

    return () => {
      clearInterval(timer);
      clearTimeout(redirectTimer);
    };
  }, []);

  if (!isVisible) return null;

  return createPortal(
    <div className="payment-success-overlay">
      <div className="payment-success-box">
        <div className="success-badge">
          <span className="checkmark">✔</span>
        </div>

        <h2>Payment Successful!</h2>

        <p>Your payment has been received successfully.</p>

        {customMessage && (
          <div className="custom-message">
            {customMessage}
          </div>
        )}

        <p className="countdown">
          Redirecting to main page in {countdown}...
        </p>
      </div>
    </div>,
    document.body
  );
};

export default PaymentSuccessScreen;


